var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-cascader"},[_c('el-cascader',{attrs:{"options":_vm.options,"props":{
      emitPath: false,
      label: 'name',
      value: 'mobile',
      children: 'children',
      multiple:true
    },"filterable":"","size":"medium","show-all-levels":false},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }